import { GetQueryParams, GetQueryResponse } from '../../../types/api.type';
import { CountryFact } from '../../../types/content.type';
import { sfcApi } from '../../api';
export interface CountryFactCreateUpdateValues {
  id?: number;
  name: string;
  content: string;
  image?: File;
  image_source: string;
}
export const countryFactApi = sfcApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountryFacts: builder.query<GetQueryResponse, GetQueryParams | void>({
      query: (params) => ({
        url: `country-facts${params?.scope ? `?scope=${params.scope}` : ''}`,
        method: 'POST',
        body: params?.data
      }),
      providesTags: ['CountryFacts']
    }),

    getCountryFact: builder.query<{ countryFact: CountryFact }, number>({
      query: (id) => `country-facts/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'CountryFacts', id }]
    }),

    createCountryFact: builder.mutation<
      { countryFact: CountryFact },
      CountryFactCreateUpdateValues
    >({
      query: (data) => {
        const formData = new FormData();
        let payload: any = {
          url: `country-facts/create`,
          method: 'POST',
          body: data
        };
        Object.entries(data).forEach(([key, value]) => formData.append(key, value));
        if (data.image?.name) {
          payload.formData = true;
        }
        if (!data?.image?.name) {
          formData.delete('image');
        }
        payload.body = formData;

        return payload;
      },
      invalidatesTags: ['CountryFacts']
    }),

    updateCountryFact: builder.mutation<
      { countryFact: CountryFact },
      CountryFactCreateUpdateValues
    >({
      query: (data) => {
        const { id } = data;
        delete data.id;
        const formData = new FormData();
        let payload: any = {
          url: `country-facts/update/${id}`,
          method: 'PUT',
          body: data
        };
        Object.entries(data).forEach(([key, value]) => formData.append(key, value));
        if (data.image?.name) {
          payload.formData = true;
        }
        if (!data?.image?.name) {
          formData.delete('image');
        }
        payload.body = formData;

        return payload;
      },
      invalidatesTags: (_result, _error, { id }) => [{ type: 'CountryFacts', id }, 'CountryFacts']
    }),

    deleteCountryFact: builder.mutation<{ countryFact: CountryFact }, number>({
      query: (id) => ({
        url: `country-facts/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['CountryFacts']
    })
  })
});

export const {
  useGetCountryFactsQuery,
  useGetCountryFactQuery,
  useCreateCountryFactMutation,
  useUpdateCountryFactMutation,
  useDeleteCountryFactMutation
} = countryFactApi;
